import { render, staticRenderFns } from "./cabecalhoDetalhar.vue?vue&type=template&id=25d9b43b&"
import script from "./cabecalhoDetalhar.vue?vue&type=script&lang=js&"
export * from "./cabecalhoDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports